
export const TemperatureGraphParameter = [
    {
        highchartsConfigs: 'highchartsConfigTemperature',
        chartLabelName: '3 month daily max/min temperatures (°C)',
        chartSeries0Name: 'High Temperature',
        chartSeries0NameColor: '#87C6D4',
        chartSeries1Name: 'Low Temperature',
        chartSeries1NameColor: '#E59E9E',
        YaxisTitle: '',
        chartSeriesShowInLegend: true,
    },
];

export const HumidityGraphParameter = [
    {
        highchartsConfigs: 'highchartsConfigHumidity',
        chartLabelName: '3 month daily max/min relative humidity (%)',
        chartSeries0Name: 'High Humidity',
        chartSeries0NameColor: '#87C6D4',
        chartSeries1Name: 'Low Humidity',
        chartSeries1NameColor: '#E59E9E',
        yaxisTitle: '',
        chartSeriesShowInLegend: true,
    },
];

export const LoadGraphParameter = [
    {
        highchartsConfigs: 'highchartsConfigLoad',
        chartLabelName: ' 3 month daily highest load graph (%)',
        chartSeries0Name: 'High Load',
        chartSeries0NameColor: '#87C6D4',
        chartSeries1Name: '',
        chartSeries1NameColor: '',
        yaxisTitle: '',
        chartSeriesShowInLegend: false,
    },
];